/* eslint-disable react/prop-types */
import { forwardRef, useState } from "react";

const AuthField = forwardRef(function AuthField({ id, label, sensitive = false, invalid = false, help, ...props }, ref) {
    const [visible, setVisible] = useState(false);
    return (
        <div>
            <label htmlFor={id} className="mb-1 block text-sm font-medium text-zinc-300">{label}</label>
            <div className="relative">
                <input {...props} ref={ref} id={id} type={sensitive ? (visible ? "text" : "password") : props.type || "text"}
                    aria-invalid={invalid} aria-describedby={[help && `${id}-help`, invalid && "auth-feedback"].filter(Boolean).join(" ") || undefined}
                    className={`auth-input block w-full rounded-xl border border-zinc-700 bg-zinc-900 px-3 py-3 text-white ${sensitive ? "pr-24" : ""}`} />
                {sensitive && <button type="button" disabled={props.disabled} onClick={() => setVisible(!visible)} aria-pressed={visible}
                    aria-label={`${visible ? "Ocultar" : "Mostrar"} ${label.toLowerCase()}`} className="auth-link absolute inset-y-0 right-3 text-xs text-zinc-300">
                    {visible ? "Ocultar" : "Mostrar"}
                </button>}
            </div>
            {help && <p id={`${id}-help`} className="mt-2 text-xs text-zinc-400">{help}</p>}
        </div>
    );
});

export default AuthField;
